<template>
  <div class="modal-city-confirmation">
    <h3 class="modal-city-confirmation__title">Хотите арендовать авто в этом городе?</h3>

    <div class="modal-city-confirmation__choice">
      <button
        @click="leaseCityIsCorrect"
        type="button"
        class="modal-city-confirmation__btn modal-city-confirmation__btn--yes"
      >
        Да
      </button>

      <button
        @click="changeRentalCity"
        type="button"
        class="modal-city-confirmation__btn modal-city-confirmation__btn--choice"
      >
        Изменить
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCityConfirmation',

  methods: {
    leaseCityIsCorrect() {
      this.$emit('leaseCityIsCorrect');
    },
    changeRentalCity() {
      this.$emit('changeRentalCity');
    }
  }
}
</script>

<style lang="sass">
.modal-city-confirmation
  padding: 10px 22px
  max-width: 214px
  font-weight: 500
  font-size: 14px
  border-radius: 6px
  background-color: #ffffff
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25)
  &::before
    content: ''
    position: absolute
    bottom: 100%
    left: 50%
    border: 7px solid transparent
    border-bottom: 7px solid #ffffff
    transform: translateX(-50%)
  &__title
    text-align: center
    font-weight: inherit
    font-size: inherit
  &__choice
    display: flex
    flex-direction: column
  &__btn
    padding: 6px
    font-weight: inherit
    font-size: inherit
    border: none
    cursor: pointer
  &__btn--yes
    background-color: $color-yellow
    margin-bottom: 6px
  &__btn--choice
</style>